module.exports = __webpack_public_path__ + "img/tb-outsider.9ae6ef1b.png";